module.exports = __webpack_public_path__ + "img/gray-fb-icon.29737e19.svg";